/**
 * The inline "Saved" confirmation, and its two second window.
 *
 * A save that says nothing leaves a person clicking the button again. A save
 * that opens a toast puts the receipt in the corner of the screen, three
 * hundred pixels from the control that earned it, which is worse: the eye is
 * already on the button.
 *
 * So the confirmation is inline, beside the control, in a polite live region,
 * and it goes away on its own because nobody needs to dismiss the word
 * "Saved". Screen spec S20 asks for exactly this on the notification
 * checkboxes, and the settings screens use it for the same reason.
 */

import { useCallback, useEffect, useRef, useState } from 'react';

export function useFlash(ms = 2000): [boolean, () => void] {
  const [on, setOn] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const flash = useCallback(() => {
    window.clearTimeout(timer.current);
    setOn(true);
    timer.current = window.setTimeout(() => setOn(false), ms);
  }, [ms]);

  return [on, flash];
}
